import { appGrowthHackingSupplyWithdrawPopupState } from "@/atoms/appGrowthHackingState"
import {
  appBorrowRepayPopupState,
  appNFTRewardModalRewardState,
  appSupplyUSDSNoticePopupState,
  appSupplyWithdrawPopupState,
} from "@/atoms/appPopupState"
import { GrowthHackingSupplyWithdrawModal } from "@/components/dashboard/modal/growthHacking/GrowthHackingSupplyWithdrawModal"
import { Container, Stack } from "@mui/material"
import { useAtomValue, useSetAtom } from "jotai"
import { Advertisement } from "./advertisement"
import { BorrowRepayModal, SupplyWithdrawModal } from "./modal"
import WithdrawUSDSNoticePopup from "./modal/withdrawUSDSNoticePopup/WithdrawUSDSNoticePopup"
import { Overview } from "./overview"

import MyAccount from "./myAccount"
import * as styles from "./styles"

import { networkAtom } from "@/atoms/settings"
import { RewardModal } from "@/components/dashboard/modal"
import useLocalStorage from "@/hooks/useLocalStorage"
import useWalletConnect from "@/hooks/useWalletConnect"
import { IS_MAINNET } from "@/utils/constants"
import { sendEventLog } from "@/utils/tracking-events"
import dynamic from "next/dynamic"
import { useCallback, useEffect } from "react"
const DynamicTitle = dynamic(() => import("@/components/dashboard/overview/DynamicOverviewTitle"), { ssr: false })

const View = () => {
  const { address, connectWallet } = useWalletConnect()

  const supplyUSDSNoticeState = useAtomValue(appSupplyUSDSNoticePopupState)
  const supplyWithdrawState = useAtomValue(appSupplyWithdrawPopupState)
  const growthHackingSupplyWithdrawState = useAtomValue(appGrowthHackingSupplyWithdrawPopupState)
  const borrowRepayState = useAtomValue(appBorrowRepayPopupState)
  const nftRewardState = useAtomValue(appNFTRewardModalRewardState)
  const setRewardModal = useSetAtom(appNFTRewardModalRewardState)
  const network = useAtomValue(networkAtom)

  const [isShowClaimNFTRewardModal, setIsShowClaimNFTRewardModal] = useLocalStorage("isShowClaimNFTRewardModal", false)
  const [isLaterClaimNFTReward] = useLocalStorage("isLaterClaimNFTReward", false)

  useEffect(() => {
    if (isLaterClaimNFTReward) return
    if (!address && !isShowClaimNFTRewardModal) {
      setRewardModal({ isOpen: true })
    }
  }, [address, isShowClaimNFTRewardModal, isLaterClaimNFTReward, setRewardModal])

  const handleGetRewardNft = useCallback(() => {
    sendEventLog("user_get_reward_nft_click", {
      isMainnet: IS_MAINNET,
    })
    setRewardModal({ isOpen: false })
    setIsShowClaimNFTRewardModal(true)
    connectWallet(network)
  }, [setIsShowClaimNFTRewardModal, setRewardModal, connectWallet, network])

  return (
    <Stack sx={styles.homeWrapper} gap={2}>
      <DynamicTitle />

      <Advertisement />

      <MyAccount />

      <Overview />

      <Container maxWidth='xl'>
        {growthHackingSupplyWithdrawState.isOpen && <GrowthHackingSupplyWithdrawModal />}
        {supplyWithdrawState.isOpen && <SupplyWithdrawModal />}
        {borrowRepayState.isOpen && <BorrowRepayModal />}
        {supplyUSDSNoticeState && <WithdrawUSDSNoticePopup />}
      </Container>

      {nftRewardState.isOpen && <RewardModal handleGetItNow={handleGetRewardNft} />}
    </Stack>
  )
}

export default View
